import React from 'react';
import { SkeletonWrapper, StyledSkeleton } from './TwoTilesComponent.skeleton.styles';
import useResponsive from '@hooks/useResponsive';

const TwoTilesComponentSkeleton = () => {
  const { fromTabletPortrait } = useResponsive();

  return (
    <SkeletonWrapper>
      <StyledSkeleton type="rect" height={fromTabletPortrait ? 346 : 500} />
      {fromTabletPortrait && <StyledSkeleton type="rect" height={346} />}
    </SkeletonWrapper>
  );
};

export default TwoTilesComponentSkeleton;
